import type { SVGProps } from 'react';
const SvgDialerSip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#dialer_sip_svg__a)">
      <path
        fill="currentColor"
        d="M17 3h-1v5h1V3Zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5Zm3-2v5h1V6h2V3h-3Zm2 2h-1V4h1v1Zm0 10.5c-1.25 0-2.45-.2-3.57-.57a.998.998 0 0 0-1.01.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1Z"
      />
    </g>
    <defs>
      <clipPath id="dialer_sip_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDialerSip;
